var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-col",
        {
          staticStyle: { display: "flex", "flex-wrap": "wrap" },
          attrs: { span: 18 }
        },
        _vm._l(_vm.row.panels, function(orderPanel, index) {
          return _c(
            "el-col",
            { key: index, staticClass: "mh-div", attrs: { span: 8 } },
            [
              _c(
                "el-card",
                { staticClass: "panel-box" },
                [
                  _c(
                    "div",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "margin-bottom": "0" } },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "sector",
                                  params: {
                                    buildingId: orderPanel.pivot.building_id,
                                    fieldId: orderPanel.pivot.field_id
                                  }
                                }
                              }
                            },
                            [
                              _c("el-col", { attrs: { span: 16 } }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(orderPanel.panel_name) +
                                    "\n                            "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          orderPanel.pivot.is_gift
                            ? _c("el-col", { attrs: { span: 3 } }, [
                                _c("span", { staticClass: "gift-logo" })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              attrs: {
                                span: 3,
                                offset: orderPanel.pivot.is_gift ? 2 : 5
                              }
                            },
                            [
                              _c("DeleteBtn", {
                                on: {
                                  clicked: function($event) {
                                    return _vm.emitDeletePanel(orderPanel)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", [
                        _c("strong", [
                          _vm._v(
                            "Sektor " +
                              _vm._s(orderPanel.field.field_number) +
                              ", Einheit " +
                              _vm._s(orderPanel.panel_number)
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Adresse")]),
                        _vm._v(": "),
                        _c("br"),
                        _vm._v(" "),
                        _c("address", [
                          _vm._v(_vm._s(_vm.row.building_address))
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        orderPanel.pivot.is_gift
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      trigger: "hover",
                                      placement: "bottom"
                                    }
                                  },
                                  [
                                    _c("strong", [_vm._v("Strasse")]),
                                    _vm._v(
                                      ": " +
                                        _vm._s(orderPanel.owner.street) +
                                        " " +
                                        _vm._s(orderPanel.owner.house_nr) +
                                        "\n                                "
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("strong", [_vm._v("PLZ")]),
                                    _vm._v(
                                      ": " +
                                        _vm._s(orderPanel.owner.zip) +
                                        "\n                                "
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("strong", [_vm._v("Stadt")]),
                                    _vm._v(
                                      ": " +
                                        _vm._s(orderPanel.owner.city) +
                                        "\n                                "
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name-wrapper",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      },
                                      [
                                        _c("strong", [_vm._v("Geschenk für")]),
                                        _vm._v(
                                          ":\n                                    "
                                        ),
                                        _c(
                                          "el-tag",
                                          { attrs: { size: "medium" } },
                                          [
                                            _vm._v(
                                              _vm._s(orderPanel.owner.name)
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _c("div", { staticStyle: { padding: "6px" } }, [
                              _c("br")
                            ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Preis")]),
                  _vm._v(
                    ": " +
                      _vm._s(_vm.get_wording("Währung", _vm.row.supplier_id)) +
                      "\n                " +
                      _vm._s(orderPanel.pivot.panel_price) +
                      "\n            "
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [
          _c("InputTemplate", {
            attrs: { commentProp: _vm.row.comment },
            on: {
              commentChange: function($event) {
                return _vm.changeComment($event, _vm.row.id)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-588910b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-588910b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/order/RowTemplate.vue
// module id = null
// module chunks = 